import { OperationResult, OperationStatus } from '../types';
import { Device } from './devices';

export enum DeviceTelemetryStatus {
  QUEUED = 'QUEUED',
  CREATED = 'CREATED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

export enum UserType {
  REGULAR = 'regular',
  THIRD_PARTY = 'third-party'
}

export interface DeviceTelemetryRequest {
  id: string;
  created_at: string;
  updated_at?: string;
  status: DeviceTelemetryStatus;
  status_reason?: string;
  device: Device;
  trace_id?: string;
}

export interface PostDeviceTelemetryPayload {
  device: Device;
}

// Type for requests grouped by status
export type DeviceTelemetryByStatus = {
  [key in DeviceTelemetryStatus]?: DeviceTelemetryRequest[];
};

// Type for telemetry data grouped by serial number
export type DeviceTelemetryBySerial = {
  [serialNumber: string]: DeviceTelemetryByStatus;
};

// Type for telemetry data grouped by device type, then by serial number
export type DeviceTelemetryMap = {
  [deviceType: string]: DeviceTelemetryBySerial;
};

export interface DeviceTelemetryInitialState {
  postDeviceTelemetry: Record<string, OperationResult>;
  getDeviceTelemetry: OperationResult;
  deviceTelemetry: DeviceTelemetryMap;
}

export const initialState: DeviceTelemetryInitialState = {
  postDeviceTelemetry: {},
  getDeviceTelemetry: {
    error: null,
    status: OperationStatus.NOT_STARTED
  },
  deviceTelemetry: {}
};
